import {USER_FORGOT_PASSWORD_FAILURE, USER_FORGOT_PASSWORD_REQUEST, USER_FORGOT_PASSWORD_SUCCESS, RESET_MESSAGE} from './constants';

export function forgetPass (data) {
    return {
        type: USER_FORGOT_PASSWORD_REQUEST,
        data
    }
}

export function forgetPassSuccess (data) {
    return {
        type: USER_FORGOT_PASSWORD_SUCCESS,
        data
    }
}

export function forgetPassFailure (data) {
    return {
        type: USER_FORGOT_PASSWORD_FAILURE,
        data
    }
}

export function resetMessage () {
    return {
        type: RESET_MESSAGE
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ForgetPassword/actions.js